<template>
  <div>
    <h1>Validation Fiches Homogénéisées</h1>
    <!-- Ligne de sélection + actions -->
    <div class="row">
      <div class="col">
        <h4>Sélection d'un fournisseur :</h4>
        <select v-model="selected.fournisseur">
          <option :value="fournisseur.Id" v-for="fournisseur in fournisseurs" :key="fournisseur.Id">{{ fournisseur.Name }} - {{ fournisseur.Code }}</option>
        </select>
      </div>
      <div class="col">
        <h4>Sélection d'une FH :</h4>
        <select v-model="selected.modele">
          <option :value="fh.Id" v-for="fh in fhs" :key="fh.Id">{{ fh.Name }}</option>
        </select>
      </div>
      <div class="col">
        <div>
          <h4>Finaliser les articles :</h4>
          <button class="btn btn-primary" v-on:click="analyse()">Analyse</button>
          <button class="btn btn-secondary" v-on:click="validate()">Validation</button>
        </div>
      </div>
    </div>
    <!-- Ligne d'analyse -->
    <div class="row">
      <div class="col" v-if="analysed.length > 0">
        <h4>Analyse des résultats</h4>
        <div>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Fournisseur</th>
                <th>Fiche</th>
                <th>Nombre d'articles</th>
                <th>Statut</th>
              </tr>
            </thead>
            <tr v-for="(a, ix) in analysed" :key="ix">
              <td>{{ a.NameFournisseur }}</td>
              <td>{{ a.NameFH }}</td>
              <td>{{ a.Counter }}</td>
              <td v-if="a.StatutFH == 0 || a.StatutFH == 1">En cours</td>
              <td v-if="a.StatutFH == 2">Finalisé</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { getFournisseurs, getFH, analyseValidateFh, validateFh } from "@/utils/bdoublewin";

  export default {
    name: "ValidationFh",
    components: {  },
    data() {
      return {
        data: [],
        aggregate: { loaded: false },
        fournisseurs: {},
        fhs: {},
        selected: {
          fournisseur: 0,
          modele: 0
        },
        analysed: []
      }
    },
    mounted() {
      // Liste des fournisseurs de BDW
      getFournisseurs().then(res => {
        this.fournisseurs = res;
      });

      // Liste des FH de BDW, trièes par ordre alphabétique
      // localeCompare pour trier même les accents
      getFH().then(res => {
        this.fhs = res.sort((a, b) => a.Name.localeCompare(b.Name));
      });
    },
    methods: {
      // Clic sur le bouton d'analyse des données
      analyse() {
        // Reset du tableau
        this.analysed = [];

        analyseValidateFh(this.selected.fournisseur, this.selected.modele).then(res => {
          this.analysed = res;
          console.log(res);
        });
      },

      // Clic sur le bouton de validation
      validate() {
        validateFh(this.selected.fournisseur, this.selected.modele).then(res => {
          this.analyse();
        })
      }
    }
  }
</script>

<style scoped>
  .btn-primary {
    border: #A7C13C !important;
    background: #A7C13C !important;
  }

  table td, table th {
      text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/BDoubleWin/ValidationFh.vue